/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Time
 *
 * 1 = Sick
 *
 * 2 = Training
 *
 * 3 = Unpaid
 *
 * 4 = BankHoliday
 *
 * 5 = Holiday
 */
export enum HolidayScheduleType {
  Time = 0,
  Sick = 1,
  Training = 2,
  Unpaid = 3,
  BankHoliday = 4,
  Holiday = 5,
}
